<div class="result-sheet">
  <div class="result-sheet__backdrop" aria-hidden="true"></div>
  <div
    class="result-sheet__panel result-card"
    [class.success]="type === 'success'"
    [class.error]="type === 'error'"
    [class.confirm]="type === 'confirm'"
    [class.confirm-destructive]="type === 'confirm' && (confirmDestructive || confirmLogout)"
    [class.confirm-logout]="type === 'confirm' && confirmLogout"
    role="alertdialog"
    aria-modal="true"
  >
    <div class="result-icon-wrap">
      <svg *ngIf="type === 'success'" class="result-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
        <path d="M8 12l3 3 5-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg *ngIf="type === 'error'" class="result-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
        <path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <svg *ngIf="type === 'confirm' && !confirmDestructive" class="result-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 12h6m0 0l-2.5-2.5M15 12l-2.5 2.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <ion-icon *ngIf="type === 'confirm' && confirmLogout" name="log-out-outline" class="result-icon result-icon-logout" aria-hidden="true"></ion-icon>
      <ion-icon *ngIf="type === 'confirm' && confirmDestructive && !confirmLogout" name="trash-outline" class="result-icon result-icon-delete" aria-hidden="true"></ion-icon>
    </div>
    <h2 class="result-title">{{ title }}</h2>
    <p class="result-message">{{ message }}</p>
    <ion-button *ngIf="type !== 'confirm'" class="result-button" expand="block" (click)="dismiss()">
      {{ displayButtonText }}
    </ion-button>
    <div *ngIf="type === 'confirm'" class="result-buttons">
      <ion-button
        class="result-button result-button-cancel"
        [fill]="confirmLogout ? 'outline' : 'solid'"
        (click)="dismiss('cancel')">
        {{ cancelButtonText }}
      </ion-button>
      <ion-button class="result-button result-button-confirm" (click)="dismiss('confirm')">
        {{ confirmButtonText }}
      </ion-button>
    </div>
  </div>
</div>
